import React from 'react';
import PropTypes from 'prop-types';

export default function CalendarIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 147999' />
      <g data-name='Grupo 36101'>
        <path
          fill={fill}
          d='m18.89 17.83-5.229-5.23a7.139 7.139 0 1 0-1.061 1.061l5.23 5.229a.375.375 0 0 0 .53 0l.53-.53a.375.375 0 0 0 0-.53ZM8.125 13.75a5.625 5.625 0 1 1 5.625-5.625 5.631 5.631 0 0 1-5.625 5.625Z'
          data-name='Caminho 1860'
        />
      </g>
    </svg>
  );
}

CalendarIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

CalendarIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
